<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kod</label>
            <input v-model="value.Code" placeholder="Kod" class="form-control"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Eksik Gün</label>
            <input v-model="value.Name" placeholder="Eksik Gün" class="form-control"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <textarea v-model="value.Description" placeholder="Açıklama" class="form-control resize-none" rows="2"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Çalışma Gün Türü</label>
            <v-select-list placeholder="Çalışma Gün Türü" :options="types" v-model="type" label="Name"></v-select-list>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.Daily">Günlük</b-form-checkbox>
        </div>
        <div class="col-12 mt-1" v-if="!value.Daily">
            <div class="alert alert-info mb-0">
                <div class="alert-body">
                    Tanımlamakta olduğunuz eksik gün kodu, ay içinde birden fazla eksik gün kodu girişi olması durumunda kullanılacak toplu eksik gün kodu olarak tanımlanacaktır.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations' 
import { BFormCheckbox } from 'bootstrap-vue';

export default{
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data(){
        return {
            types:[]
        }
    },
    mounted(){
        this.getWorkingType()
    },
    methods:{
        getWorkingType(){
            EmployeeOperationsApi.Score.WorkingType().then(res => {
                this.types = res.data.Data
            })
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.EmployeeWorkingTypeId)
            },
            set:function(value){
                this.value.EmployeeWorkingTypeId = value?.Id || null
            }
        }
    }
}
</script>
